<template>
  <div class="modal-container">
    <div class="modal">
      <a @click="hideModal"
        ><v-icon name="times" scale="1.6" class="modal__close-icon"
      /></a>
      <slot />
    </div>
  </div>
</template>

<script>
import Icon from "vue-awesome/components/Icon";

export default {
  components: {
    "v-icon": Icon
  },
  methods: {
    hideModal() {
      // console.log("Component: hiding");
      this.$emit("hideModal");
    }
  }
};
</script>

<style scoped>
.modal-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(47, 58, 87, 0.5);
  z-index: 5;
}

.modal {
  position: relative;
  width: 448px;
  padding: 30px 24px;
  background-color: #ffffff;
  box-shadow: 0px 4px 25px #0c1220;
  border-radius: 15px;
  color: #222c44;
}

.modal__close-icon {
  position: absolute;
  top: 24px;
  right: 24px;
  color: #979797;
  cursor: pointer;
}

.modal__title {
  font-size: 36px;
  font-weight: normal;
}

@media (max-width: 600px) {
  .modal__title {
    font-size: 23px;
  }
}
</style>
